import type { ZodSchema } from 'zod';

// Import runner argument schemas (default exports) for each step
import AddOffsetArgs from '@sb/routine-runner/Step/AddOffset/Arguments';
import AnticipatePayloadArgs from '@sb/routine-runner/Step/AnticipatePayload/Arguments';
import ArcArgs from '@sb/routine-runner/Step/Arc/Arguments';
import CaptureArgs from '@sb/routine-runner/Step/Capture/Arguments';
import ClassifyArgs from '@sb/routine-runner/Step/Classify/Arguments';
import CodeBlockArgs from '@sb/routine-runner/Step/CodeBlock/Arguments';
import CreateRecordingArgs from '@sb/routine-runner/Step/CreateRecording/Arguments';
import IfArgs from '@sb/routine-runner/Step/If/Arguments';
import LocateArgs from '@sb/routine-runner/Step/Locate/Arguments';
import LoopArgs from '@sb/routine-runner/Step/Loop/Arguments';
import LoopControlArgs from '@sb/routine-runner/Step/LoopControl/Arguments';
import MoveArmToArgs from '@sb/routine-runner/Step/MoveArmTo/Arguments';
import MoveArmToV2Args from '@sb/routine-runner/Step/MoveArmToV2/Arguments';
import { NetworkRequestArguments } from '@sb/routine-runner/Step/NetworkRequest/Arguments';
import OperateEquipmentArgs from '@sb/routine-runner/Step/OperateEquipment/Arguments';
import PressButtonArgs from '@sb/routine-runner/Step/PressButton/Arguments';
import PushModeArgs from '@sb/routine-runner/Step/PushMode/Arguments';
import RunInBackgroundArgs from '@sb/routine-runner/Step/RunInBackground/Arguments';
import RunSkillArgs from '@sb/routine-runner/Step/RunSkill/Arguments';
import SetEnvironmentVariableArgs from '@sb/routine-runner/Step/SetEnvironmentVariable/Arguments';
import SetIOArgs from '@sb/routine-runner/Step/SetIO/Arguments';
import TriggerFaultArgs from '@sb/routine-runner/Step/TriggerFault/Arguments';
import UpdateVisualizationArgs from '@sb/routine-runner/Step/UpdateVisualization/Arguments';
import WaitArgs from '@sb/routine-runner/Step/Wait/Arguments';
import WaitForConfirmationArgs from '@sb/routine-runner/Step/WaitForConfirmation/Arguments';
import WaypointArgs from '@sb/routine-runner/Step/Waypoint/Arguments';

const stepKindToSchema: Record<string, ZodSchema<any>> = {
  AddOffset: AddOffsetArgs,
  AnticipatePayload: AnticipatePayloadArgs,
  Arc: ArcArgs,
  Capture: CaptureArgs,
  Classify: ClassifyArgs,
  CodeBlock: CodeBlockArgs,
  CreateRecording: CreateRecordingArgs,
  If: IfArgs,
  Locate: LocateArgs,
  Loop: LoopArgs,
  LoopControl: LoopControlArgs,
  MoveArmTo: MoveArmToArgs,
  MoveArmToV2: MoveArmToV2Args,
  NetworkRequest: NetworkRequestArguments,
  OperateEquipment: OperateEquipmentArgs,
  PressButton: PressButtonArgs,
  PushMode: PushModeArgs,
  RunInBackground: RunInBackgroundArgs,
  RunSkill: RunSkillArgs,
  SetEnvironmentVariable: SetEnvironmentVariableArgs,
  SetIO: SetIOArgs,
  TriggerFault: TriggerFaultArgs,
  UpdateVisualization: UpdateVisualizationArgs,
  Wait: WaitArgs,
  WaitForConfirmation: WaitForConfirmationArgs,
  Waypoint: WaypointArgs,
};

/**
 * Get the Zod schema for a given stepKind from Routine Runner.
 *
 * @param stepKind - The canonical step kind
 * @returns Zod schema or undefined if not found
 */
export function getRunnerArgsSchema(
  stepKind: string,
): ZodSchema<any> | undefined {
  return stepKindToSchema[stepKind];
}
